/**
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-header.html';

export default defineComponent({
  name: 'SetupHeader',
  template,
  emits: {
    back() {}
  },
  methods: {
    onBack() {
      this.$emit('back');
    }
  },
  props: {
    isOnline: { type: Boolean, required: true },
    title: { type: String, required: true }
  }
});
